import type { NewsArticle } from '../types/news';

export const INITIAL_NEWS: NewsArticle[] = [
  {
    id: 'ordenaciones-presbiterales-2026',
    slug: 'ordenaciones-presbiterales',
    title: 'Ordenaciones Presbiterales',
    subtitle: 'Juan Pedro Calanni y Cristian Felipe Triana recibieron el sagrado orden del presbiterado',
    date: '2026-06-06',
    displayDate: '6 de junio de 2026',
    category: 'Ordenaciones',
    author: 'Seminario Misionero Arquidiocesano Redemptoris Mater',
    coverImage: '/assets/hero/ordenaciones.webp',
    coverImageAlt: 'Ordenaciones Presbiterales en la Catedral Metropolitana de Medellín',
    summary: 'El pasado 6 de junio de 2026, en la Catedral Metropolitana de Medellín, tuvimos la alegría de vivir la ordenación presbiteral de dos hermanos nuestros: Juan Pedro Calanni y Cristian Felipe Triana.',
    content: [
      'El pasado 6 de junio de 2026, en la Catedral Metropolitana de Medellin, tuvimos la alegria de vivir la ordenacion presbiteral de dos hermanos nuestros: Juan Pedro Calanni (Cipoletti, Argentina) y Cristian Felipe Triana (Bogotá, Colombia). La Ordenación fue presidida por Mons. Ricardo Tobon Restrepo, nuestro Arzobispo.',
      'Ha sido este un momento de gracia y alegria para todo el Seminario, poder contemplar la elección y la obra de Dios en la vida de estos hermanos. Bendecimos nuevamente al Señor que generosamente regala dos nuevos ministros a su Iglesia, para que a traves de sus manos consagradas, puedan ejercer el sacerdocio de Cristo en la tierra.'
    ],
    gallery: [
      {
        src: '/images/noticias/ordenaciones/3.webp',
        alt: 'Imposición de manos durante la ordenación sacerdotal',
        caption: 'Momento solemne de la imposición de manos'
      },
      {
        src: '/images/noticias/ordenaciones/9.webp',
        alt: 'Liturgia de consagración y promesas de los ordenandos',
        caption: 'Promesa de obediencia y entrega al ministerio'
      },
      {
        src: '/images/noticias/ordenaciones/12.webp',
        alt: 'Revestimiento de las vestiduras sagradas',
        caption: 'Revestimiento de los nuevos presbíteros'
      },
      {
        src: '/images/noticias/ordenaciones/14.webp',
        alt: 'Abrazo de paz y bienvenida al clero arquidiocesano',
        caption: 'Acogida en el presbiterio de Medellín'
      },
      {
        src: '/images/noticias/ordenaciones/16.webp',
        alt: 'Concelebración en el altar mayor de la Catedral',
        caption: 'Primera concelebración eucarística'
      },
      {
        src: '/images/noticias/ordenaciones/17.webp',
        alt: 'Comunidad reunida celebrando los nuevos pastores',
        caption: 'Gozo de la comunidad y del Seminario'
      }
    ],
    featured: true,
    tags: ['Ordenaciones', 'Sacerdocio', 'Seminario', 'Medellín']
  },
  {
    id: 'ordenaciones-diaconales-2026',
    slug: 'ordenaciones-diaconales',
    title: 'Ordenaciones Diaconales',
    subtitle: 'Eduardo Elías Rayo Fernández y Mauricio Dávila Osorio fueron ordenados diáconos hacia el presbiterado',
    date: '2026-05-16',
    displayDate: '16 de mayo de 2026',
    category: 'Ordenaciones',
    author: 'Seminario Misionero Arquidiocesano Redemptoris Mater',
    coverImage: '/images/noticias/ordenacionesDiaconales/portada.webp',
    coverImageAlt: 'Ordenaciones Diaconales en la Catedral Basílica Metropolitana de Medellín',
    summary: 'El pasado 16 de mayo del 2026, en la Catedral Basílica Metropolitana de la Inmaculada Concepción de Medellín, tuvimos la alegría de celebrar la ordenación diaconal de dos hermanos nuestros: Eduardo Elías Rayo Fernández y Mauricio Dávila Osorio.',
    content: [
      'El pasado 16 de mayo del 2026, en la Catedral Basílica Metropolitana de la Inmaculada Concepción de Medellín, tuvimos la alegría de celebrar la ordenación de 6 diáconos en camino hacia el presbiterado y 4 diáconos permanentes.',
      'De nuestro seminario se ordenaron diáconos dos hermanos nuestros: Eduardo Elías Rayo Fernández (México) y Mauricio Dávila Osorio (Itagüí).',
      'La eucaristía la presidió Mons. Ricardo Tobon Restrepo, Arzobispo de Medellín. En su homilía, nos invitaba a responder al llamado del Señor de manera generosa, sabiendo que la fuerza de su Espíritu Santo, nos precede y nos hace ser testigos de la resurrección, allí donde la Iglesia nos envíe.',
      'Ha sido este un momento más para bendecir al Señor por los nuevos ministros que da a la Iglesia y que nos recuerdan que Dios es fiel y que es necesario continuar rogando al dueño de la mies, que envié obreros a su mies.'
    ],
    gallery: [
      {
        src: '/images/noticias/ordenacionesDiaconales/5.webp',
        alt: 'Procesión de entrada y asamblea en la Catedral Metropolitana',
        caption: 'Procesión inicial en la Catedral Basílica Metropolitana'
      },
      {
        src: '/images/noticias/ordenacionesDiaconales/9.webp',
        alt: 'Monseñor Ricardo Tobón presidiendo la liturgia',
        caption: 'Homilía y presidencia de Mons. Ricardo Tobón Restrepo'
      },
      {
        src: '/images/noticias/ordenacionesDiaconales/11.webp',
        alt: 'Promesa de obediencia y entrega diaconal',
        caption: 'Compromiso de fidelidad y servicio al altar'
      },
      {
        src: '/images/noticias/ordenacionesDiaconales/13.webp',
        alt: 'Momento de la imposición de manos por el Arzobispo',
        caption: 'Imposición de manos para la consagración diaconal'
      },
      {
        src: '/images/noticias/ordenacionesDiaconales/15.webp',
        alt: 'Revestimiento con la estola al estilo diaconal y la dalmática',
        caption: 'Revestimiento de los nuevos diáconos con la dalmática'
      },
      {
        src: '/images/noticias/ordenacionesDiaconales/17.webp',
        alt: 'Entrega del libro de los Evangelios',
        caption: "Entrega de los Santos Evangelios: 'Cree lo que lees, enseña lo que crees'"
      },
      {
        src: '/images/noticias/ordenacionesDiaconales/18.webp',
        alt: 'Saludo fraterno y abrazo de paz del Arzobispo',
        caption: 'Saludo de paz y acogida en el ministerio diaconal'
      },
      {
        src: '/images/noticias/ordenacionesDiaconales/19.webp',
        alt: 'Nuevos diáconos sirviendo en el altar mayor',
        caption: 'Servicio de los nuevos diáconos en el altar'
      }
    ],
    featured: false,
    tags: ['Ordenaciones', 'Diaconado', 'Seminario', 'Medellín']
  },
  {
    id: 'fiesta-del-seminario-2026',
    slug: 'fiesta-del-seminario',
    title: 'Fiesta del Seminario',
    subtitle: 'Celebración de la fiesta patronal en comunión con las casas de formación de la arquidiócesis',
    date: '2026-04-15',
    displayDate: '15 de abril de 2026',
    category: 'Vida Comunitaria',
    author: 'Seminario Misionero Arquidiocesano Redemptoris Mater',
    coverImage: '/images/noticias/fiestaSeminario/portada.webp',
    coverImageAlt: 'Fiesta patronal del Seminario Redemptoris Mater de Medellín',
    summary: 'El pasado miércoles 15 de abril, hemos vivido la fiesta patronal de nuestro seminario en compañía de los seminaristas que conforman las diversas casas de formación de nuestra arquidiócesis.',
    content: [
      'El pasado miércoles 15 de abril, hemos vivido la fiesta patronal de nuestro seminario en compañía de los seminaristas que conforman las diversas casas de formación de nuestra arquidiócesis.',
      'Ha sido un momento de gracia y comunión en donde juntos hemos dado gracias al señor por la vida y el don de nuestra vocación.',
      'En la homilía, Monseñor Ricardo nos recordaba que la acción de gracias no se limita a un mero formalismo, sino que cuando es genuino nos mueve a darlo todo por amor a Aquel que se ha fijado en nosotros y nos está configurando paulatinamente con la imagen de Cristo.',
      'Ha sido un encuentro fraterno y lleno de la alegría de Cristo Resucitado.'
    ],
    gallery: [
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-2-801.webp',
        alt: 'Momento de la celebración litúrgica de la fiesta patronal',
        caption: 'Celebración litúrgica y eucaristía solemne'
      },
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-4-80.webp',
        alt: 'Homilía de Monseñor Ricardo Tobón Restrepo',
        caption: 'Homilía de Monseñor Ricardo Tobón Restrepo'
      },
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-5-80.webp',
        alt: 'Concelebración y comunión fraterna entre seminarios',
        caption: 'Concelebración y acción de gracias'
      },
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-15-80.webp',
        alt: 'Encuentro fraterno entre seminaristas',
        caption: 'Encuentro y convivencia fraterna'
      },
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-16-80.webp',
        alt: 'Compartir en la fiesta del seminario',
        caption: 'Alegría y compartir comunitario'
      },
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-17-80.webp',
        alt: 'Casas de formación unidas en fraternidad',
        caption: 'Casas de formación de la arquidiócesis reunidas'
      },
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-18-80.webp',
        alt: 'Momento comunitario de acción de gracias',
        caption: 'Comunión en la alegría de Cristo Resucitado'
      },
      {
        src: '/images/noticias/fiestaSeminario/mesa-de-trabajo-19-80.webp',
        alt: 'Fraternidad entre los formadores y seminaristas',
        caption: 'Fraternidad y gozo de la vocación sacerdotal'
      }
    ],
    featured: false,
    tags: ['Fiesta Patronal', 'Seminario', 'Vocación', 'Comunidad']
  }
];

const LOCAL_STORAGE_KEY = 'srmm_custom_news_v1';
let cachedNews: NewsArticle[] | null = null;

export const newsService = {
  /**
   * Obtiene todas las noticias. Primero revisa si hay datos locales modificados,
   * luego intenta cargar /data/news.json en tiempo de ejecución (para cambios sin tocar código),
   * y recurre a INITIAL_NEWS si no hay conexión o falla la petición.
   */
  async getAllNews(): Promise<NewsArticle[]> {
    if (cachedNews) {
      return cachedNews;
    }

    // 1. Revisar si hay noticias personalizadas en localStorage (para pruebas o admin local)
    if (typeof window !== 'undefined') {
      try {
        const localData = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (localData) {
          const parsed = JSON.parse(localData);
          if (Array.isArray(parsed) && parsed.length > 0) {
            cachedNews = parsed;
            return parsed;
          }
        }
      } catch (err) {
        console.warn('Error reading news from localStorage:', err);
      }
    }

    // 2. Intentar cargar el archivo JSON público estático
    try {
      const response = await fetch('/data/news.json', { cache: 'no-cache' });
      if (response.ok) {
        const data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
          cachedNews = data;
          return data;
        }
      }
    } catch (err) {
      console.warn('Could not fetch /data/news.json, falling back to bundled news:', err);
    }

    // 3. Fallback a las noticias iniciales por defecto
    cachedNews = INITIAL_NEWS;
    return INITIAL_NEWS;
  },

  /**
   * Obtiene una noticia por su slug (o id).
   */
  async getNewsBySlug(slug: string): Promise<NewsArticle | undefined> {
    const all = await this.getAllNews();
    return all.find((item) => item.slug === slug || item.id === slug);
  },

  /**
   * Obtiene noticias sincrónicamente para render inicial inmediato sin layout shifts.
   */
  getInitialNews(): NewsArticle[] {
    if (typeof window !== 'undefined') {
      try {
        const localData = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (localData) {
          const parsed = JSON.parse(localData);
          if (Array.isArray(parsed) && parsed.length > 0) return parsed;
        }
      } catch {
        // ignore
      }
    }
    return INITIAL_NEWS;
  },

  /**
   * Invalida la caché para forzar recarga de noticias.
   */
  invalidateCache(): void {
    cachedNews = null;
  },

  /**
   * Permite guardar o actualizar noticias (para futura integración de panel o app administrativa).
   */
  saveNews(newsList: NewsArticle[]): void {
    cachedNews = newsList;
    if (typeof window !== 'undefined') {
      try {
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(newsList));
      } catch (err) {
        console.error('Error saving news to localStorage:', err);
      }
    }
  }
};
